import React, { createContext, useMemo } from 'react';
import type { SDK, AppNavigate } from './types';
import type { Theme } from './theme';
import { lightTheme } from './theme';
import { ThemeContext } from './ThemeContext';

export const SDKContext = createContext<SDK | null>(null);
export const AppNavigateContext = createContext<AppNavigate | null>(null);

interface SDKProviderProps {
  appId: string;
  platform: SDK['platform'];
  navigate: AppNavigate;
  modules?: Record<string, unknown>;
  /**
   * Active theme. Detect system preference in the host app and pass the
   * resolved theme here. Defaults to lightTheme if omitted.
   */
  theme?: Theme;
  children: React.ReactNode;
}

export function SDKProvider({ appId, platform, navigate, modules, theme, children }: SDKProviderProps) {
  const resolvedTheme = theme ?? lightTheme;

  const sdk = useMemo<SDK>(() => ({
    appId,
    platform,
    modules: modules ?? {},
    theme: resolvedTheme,
  }), [appId, platform, modules, resolvedTheme]);

  return (
    <ThemeContext.Provider value={resolvedTheme}>
      <SDKContext.Provider value={sdk}>
        <AppNavigateContext.Provider value={navigate}>
          {children}
        </AppNavigateContext.Provider>
      </SDKContext.Provider>
    </ThemeContext.Provider>
  );
}
